import React, { useEffect, useState } from 'react';
import '../css/main.css';
import {addPropertyValidation} from '../components/validation';
import AddPropertyFormAction from '../components/addPropertyFormAction';
import ImageUploading from "react-images-uploading";
import axios from 'axios';
export const AddPropertyForm = () =>{
    const [addProperty, setaddPropertyForm]=useState({propetyName:'',propertyDocumentFiles:[],subLocation:'',youtubeEmbededLink:'',locationAddress:'',areaSqft:'',priceSqft:'',UdsValue:'',bedRoomNo:'',toiletNo:'',parkingNo:'',areaBuiltUp:'',houseVillaNumber:'',waterSupplyCapacity:'',Sump:'',Oth:'',ResidentialType:'',uploaddocumentFile:[],uploadLogoFile:null,aboutProperty:'',googleMap:'',imageUploadList:[],successMessage:'',propertyType:'',SquereFeetSquareYard:'',pricePerSqrFt:'',total:'',file:[],fileObj:[],filesLocation:[],uploadDocumentObj:[]});
    const [errors,seterrors]=useState({});
    const fileObj=[];
    const fileArray = [];
    const uploadFileArray=[];
    const fileUploadDocuments=[];
    const maxNumber = 5;
    const multipleImageUpload = (imageList) =>{
        console.log(imageList);
        var images = imageList.length
    
     //Saving multiple images in formadta varibale
     //for(var a = 0; a<images; a++)
     //{
     // addProperty.imageUploadList.push(imageList[a]) 
      
     //}
        console.log(addProperty.imageUploadList)
    }
    const logoUpload = (e) =>{
        e.preventDefault();
        setaddPropertyForm({...addProperty,uploadLogoFile:e.target.files[0]})
    }
    const uploaddocumentFile = (e) =>{
        e.preventDefault();
        var files=e.target.files;
        for(var a=0;a<files.length;a++){
            addProperty.uploaddocumentFile.push(files[a])
            
            
        }
        const lenghtImage=addProperty.uploaddocumentFile.length;
        for(var a=0;a<lenghtImage;a++){
            console.log(addProperty.uploaddocumentFile[a].name)
        }
        
        addProperty.uploadDocumentObj.push(e.target.files);
        for (let i = 0; i < addProperty.uploadDocumentObj[0].length; i++) {
            uploadFileArray.push(URL.createObjectURL(addProperty.uploadDocumentObj[0][i]))
            
 

        }

        setaddPropertyForm({
            ...addProperty,
            propertyDocumentFiles:uploadFileArray

        })
    }
    const uploadMultipleFiles = (e) =>{
        e.preventDefault();
        var files=e.target.files;
        if(files.length>5){
            alert('Please Select only 5 Files Only')
        }
        else{

        
        for(var a=0;a<files.length;a++){
            addProperty.imageUploadList.push(files[a])
            
            
        }
        const lenghtImage=addProperty.imageUploadList.length;
        for(var a=0;a<lenghtImage;a++){
            console.log(addProperty.imageUploadList[a].name)
        }
        
        addProperty.fileObj.push(e.target.files);
        for (let i = 0; i < addProperty.fileObj[0].length; i++) {
            fileArray.push(URL.createObjectURL(addProperty.fileObj[0][i]))
            
 

        }
        console.log(fileArray)
                
        setaddPropertyForm({
            ...addProperty,
            file: fileArray
        });
        
    }
    }
    const AddPropertyForm =  async e =>{
        e.preventDefault();
        const validationErrors=addPropertyValidation(addProperty);
        const noErrors = Object.keys(validationErrors).length === 0;
        if(noErrors){
            AddPropertyFormAction(addProperty).then((res) => {
                console.log(res.data);
                if(res.data.success===1){
                    console.log(res.data);
                    console.log(res.data.propertyName);
                    const formData=new FormData();
                    formData.append('Name',res.data.propertyName);
                    if(addProperty.uploaddocumentFile){
                        const lenghtDocument=addProperty.uploaddocumentFile.length;
                        for(let i=0;i<lenghtDocument;i++){
                            formData.append('uploadedDocuments'+i, 
                            addProperty.uploaddocumentFile[i], 
                            addProperty.uploaddocumentFile[i].name);
                        }
                        
                      }
                    axios.post('https://internationalstrategicconsultants.com/iscPropExApi/PropertyPdfsUpload.php', formData
                        ).then(res => {
                            setaddPropertyForm({
                                ...addProperty,
                                successMessage:res.data.message
                              })
                              alert(res.data.message);
                              window.location.reload(true);
                            
                        
                        })
                        .catch(error => {
                               
                            }
                            ); 
                    
                      
                      
                 
                 
                }
                else{
                    setaddPropertyForm({
                    ...addProperty,
                    successMessage:res.data.errorMessage
                  })
                }
            })
            .catch(err=>{

            }) 

            
        }
        else{
            alert('Please Fill up The Form');
        }
    }
    return(
        <>

        <section className="propertyList-Form-Add">
            <div className="container">
           
                <div className="row">
                    <div className="col-md-12 col-lg-12">
                        <h4 className="property-title" style={{color:"#323499",textAlign:"center"}}><span style={{color:"#ec559a"}}>I want to exchange</span><br/>
                        My Property for buying a New Property</h4>
                    </div>
                </div>
                <div className="row" style={{justifyContent:"center",marginTop:"40px"}}>
                    <div className="col-md-8 col-lg-8">
                        <form method="post" encType="multipart/form-data">
                           <div class="button-wrap" style={{marginBottom:"30px;"}}>
                                <label class="file-button" for="upload-Logo">Upload Property Logo</label>
                                <input id="upload-Logo"type="file" className="form-control" onChange={logoUpload} />
                            </div>
                            <div className="form-group">
                                <input type="text" className="form-control" name="propetyName" placeholder="Name of the Property" onChange={e=>setaddPropertyForm({...addProperty,propetyName:e.target.value})} value={addProperty.propetyName}></input>
                                
                            </div>
                            <div className="form-group">
                                <select name="propertyType" className="form-control" onChange={e=>setaddPropertyForm({...addProperty,propertyType:e.target.value})} value={addProperty.propertyType}>
                                    <option>Property type</option>
                                    <option value="Residential">Residential</option>
                                    <option value="Commercial">Commercial</option>
                                </select>
                                
                            </div>
                            {
                                addProperty.propertyType==='Residential'?
                                <div className="form-group">
                                    <select name="ResidentialType" className="form-control" onChange={e=>setaddPropertyForm({...addProperty,ResidentialType:e.target.value})} value={addProperty.ResidentialType}>
                                        <option>Residential Type</option>
                                        <option value="Land">Land</option>
                                        <option value="Apartment">Apartment</option>
                                        <option value="House or villa">House or villa</option>
                                        <option value="Gated community">Gated community</option>
                                    </select>
                                    
                                </div>
                                :
                                null
                                  
                            }
                            <div className="form-group">
                                <textarea className="form-control" name="locationAddress" placeholder="Location" onChange={e=>setaddPropertyForm({...addProperty,locationAddress:e.target.value})} value={addProperty.locationAddress}>

                                </textarea>
                            </div>
                            <div className="form-group">
                                <textarea className="form-control" name="subLocation" placeholder="Sub Location" onChange={e=>setaddPropertyForm({...addProperty,subLocation:e.target.value})} value={addProperty.subLocation}>

                                </textarea>
                            </div>
                            <div className="form-group">
                                <textarea className="form-control" name="aboutProperty" placeholder="About Property" onChange={e=>setaddPropertyForm({...addProperty,aboutProperty:e.target.value})} value={addProperty.aboutProperty}>

                                </textarea>
                            </div>
                            <div className="form-group">
                                <input type="url" name="googleMap" className="form-control" placeholder="Paste Google Map Link" onChange={e=>setaddPropertyForm({...addProperty,googleMap:e.target.value})} value={addProperty.googleMap} />
                                <span><sup>*</sup> Please Paste the Google Map Share Iframe src Link</span>
                            </div>
                            <div className="form-group">
                                <input type="url" name="youtubeEmbededLink" className="form-control" placeholder="Paste Youtube Embedded Iframe Src" onChange={e=>setaddPropertyForm({...addProperty,youtubeEmbededLink:e.target.value})} value={addProperty.youtubeEmbededLink} />
                                <span><sup>*</sup> Please Paste the Youtube Embedded Iframe src Link</span>
                            </div>
                            
                            {
                                addProperty.propertyType==='Residential'?
                                addProperty.ResidentialType==='Land' ?
                                <>
                                <div className="form-group">
                                    <input type="text" className="form-control" name="areaSqft" placeholder="Plot Area in sq ft" onChange={e=>setaddPropertyForm({...addProperty,areaSqft:e.target.value})} value={addProperty.areaSqft}></input>
                                    
                                </div>
                                <div className="form-group">
                                    <input type="text" className="form-control" name="priceSqft" placeholder="Price per sq ft" onChange={e=>setaddPropertyForm({...addProperty,priceSqft:e.target.value})} value={addProperty.priceSqft}></input>
                                    
                                </div>
                                </>
                                : addProperty.ResidentialType==='Apartment' ?
                                <>
                                <div className="form-group">
                                    <input type="text" className="form-control" name="areaSqft" placeholder="Area in sq ft" onChange={e=>setaddPropertyForm({...addProperty,areaSqft:e.target.value})} value={addProperty.areaSqft}></input>
                                    
                                </div>
                                <div className="form-group">
                                    <input type="text" className="form-control" name="priceSqft" placeholder="Price per sq ft" onChange={e=>setaddPropertyForm({...addProperty,priceSqft:e.target.value})} value={addProperty.priceSqft}></input>
                                    
                                </div>
                                <div className="form-group">
                                    <input type="text" className="form-control" name="UdsValue" placeholder="UDS value" onChange={e=>setaddPropertyForm({...addProperty,UdsValue:e.target.value})} value={addProperty.UdsValue}></input>
                                    
                                </div>
                                <div className="form-group">
                                    <input type="text" className="form-control" name="bedRoomNo" placeholder="No of bedrooms" onChange={e=>setaddPropertyForm({...addProperty,bedRoomNo:e.target.value})} value={addProperty.bedRoomNo}></input>
                                    
                                </div>
                                <div className="form-group">
                                    <input type="text" className="form-control" name="toiletNo" placeholder="No of toilets" onChange={e=>setaddPropertyForm({...addProperty,toiletNo:e.target.value})} value={addProperty.toiletNo}></input>
                                    
                                </div>
                                <div className="form-group">
                                    <input type="text" className="form-control" name="parkingNo" placeholder="No of parking" onChange={e=>setaddPropertyForm({...addProperty,parkingNo:e.target.value})} value={addProperty.parkingNo}></input>
                                    
                                </div>

                                </>
                                : addProperty.ResidentialType==='House or villa' || addProperty.ResidentialType==='Gated community' ?
                                <>
                                   <div className="form-group">
                                        <input type="text" className="form-control" name="areaSqft" placeholder="Area of land in sq ft" onChange={e=>setaddPropertyForm({...addProperty,areaSqft:e.target.value})} value={addProperty.areaSqft}></input>
                                        
                                    </div>
                                    <div className="form-group">
                                        <input type="text" className="form-control" name="areaBuiltUp" placeholder="Built up area of land in sq ft" onChange={e=>setaddPropertyForm({...addProperty,areaBuiltUp:e.target.value})} value={addProperty.areaBuiltUp}></input>
                                        
                                    </div>
                                    <div className="form-group">
                                        <input type="text" className="form-control" name="houseVillaNumber" placeholder="House or villa number" onChange={e=>setaddPropertyForm({...addProperty,houseVillaNumber:e.target.value})} value={addProperty.houseVillaNumber}></input>
                                        
                                    </div>
                                    <div className="form-group">
                                        <input type="text" className="form-control" name="bedRoomNo" placeholder="No of bedrooms" onChange={e=>setaddPropertyForm({...addProperty,bedRoomNo:e.target.value})} value={addProperty.bedRoomNo}></input>
                                        
                                    </div>
                                    <div className="form-group">
                                        <input type="text" className="form-control" name="toiletNo" placeholder="No of toilets" onChange={e=>setaddPropertyForm({...addProperty,toiletNo:e.target.value})} value={addProperty.toiletNo}></input>
                                        
                                    </div>
                                    <div className="form-group">
                                        <input type="text" className="form-control" name="parkingNo" placeholder="No of parking" onChange={e=>setaddPropertyForm({...addProperty,parkingNo:e.target.value})} value={addProperty.parkingNo}></input>
                                        
                                    </div>
                                    <div className="form-group">
                                        <input type="text" className="form-control" name="waterSupplyCapacity" placeholder="Capacity of water facilities" onChange={e=>setaddPropertyForm({...addProperty,waterSupplyCapacity:e.target.value})} value={addProperty.waterSupplyCapacity}></input>
                                        
                                    </div>
                                    <div className="form-group">
                                        <input type="text" className="form-control" name="Sump" placeholder="Sump" onChange={e=>setaddPropertyForm({...addProperty,Sump:e.target.value})} value={addProperty.Sump}></input>
                                        
                                    </div>
                                    <div className="form-group">
                                        <input type="text" className="form-control" name="Oth" placeholder="Other" onChange={e=>setaddPropertyForm({...addProperty,Oth:e.target.value})} value={addProperty.Oth}></input>
                                        
                                    </div>
                                </>
                                :
                                null
                              :
                              null
                            }
                            {
                                addProperty.propertyType==='Commercial'?
                                <>
                                <div className="form-group">
                                <input type="text" className="form-control" name="areaSqft" placeholder="Plot Area in Sq Yd" onChange={e=>setaddPropertyForm({...addProperty,areaSqft:e.target.value})} value={addProperty.areaSqft}></input>
                                
                                </div>
                                <div className="form-group">
                                <input type="text" className="form-control" name="priceSqft" placeholder="Price per Sq Yd" onChange={e=>setaddPropertyForm({...addProperty,priceSqft:e.target.value})} value={addProperty.priceSqft}></input>
                                
                                </div>
                                </>
                                
                            : null
                            }
                            
                            
                            <div className="form-group">
                                <input type="text" className="form-control" name="total" placeholder="Total" style={{marginBottom:"10px"}} onChange={e=>setaddPropertyForm({...addProperty,total:e.target.value})} value={addProperty.total}></input>
                                <span><sup>*</sup> Actual price may differ, kindly talk to our representative</span>
                            </div>
                            <div class="button-wrap" style={{marginBottom:"30px;"}}>
                                <label class="file-button" for="upload-document">Upload Property Document/Brochure</label>
                                <input id="upload-document"type="file" className="form-control" onChange={uploaddocumentFile} multiple/>
                            </div>
                            <div className="row">
                            {
                                (addProperty. propertyDocumentFiles|| []).map(url => (
                                   <div className="col-md-4 col-lg-4" key={url.id} id={url.id} style={{marginTop:"30px"}}>
                                       <iframe src={url} style={{width:"100%",border:"1px solid #dadadc",borderRadius:"10px"}} />
                                       
                                    </div>
                                ))
                                }
                            </div>
                            <div class="button-wrap">
                                <label class="file-button" for="upload">Upload Property Photos</label>
                                <input id="upload" type="file" onChange={uploadMultipleFiles} multiple accept="image/*"/>
                                
                                
                                
                                
                            </div>
                            
                            <div className="row">
                            {
                                (addProperty.file || []).map(url => (
                                   <div className="col-md-4 col-lg-4" key={url.id} id={url.id} style={{marginTop:"30px"}}>
                                       <img src={url} alt="..." style={{width:"100%",border:"1px solid #dadadc",borderRadius:"10px"}}/>
                                    </div>
                                ))
                            }
                            </div>
                            <p style={{color:"#fff",fontSize:"18px",textAlign:"center" }}>{addProperty.successMessage}</p>
                            <div className="submit-button">
                               <input type="submit" className="btn btn-lg btn-submit" value="Add My Property" onClick={AddPropertyForm}/>
                           </div>
 
                        </form>
                        
                    </div>
                </div>
                

            </div>
        </section>
        </>
    )
}